import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'


const MixState = (props) => {
    const { sessions, cps } = props.systemStats
    const { total, postpay } = props.accountStats
    return (
        <div className="row">
            <div className="col-lg-4 col-md-12">
                <div style={{borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.2)',border:'none'}} className="card card-body bg-white text-black has-bg-image">
                  <div className='d-flex justify-content-between'>
                    <div className="media mb-3">
                        <div className="media-body">
                            <h6 className="font-weight-semibold mb-0 fs-22">
                            Sessions: 
                            <span style={{fontSize:'20px',fontWeight:'bold',color:'#413839'}}> {sessions} / </span><span style={{fontSize:'20px',fontWeight:'bold',color:'#413839'}}>15000</span>
                            </h6>
                        </div>
                    </div>
                    <div className='d-flex flex-column'>
                        <div className="ml-2 align-self-center">
                            <i style={{color:'#00c292'}} class="icon-history fs-40x " />
                        </div> 
                    </div>
                    </div>
                    <div className="mb-2">
                        <ProgressBar animated now={sessions} max={15000} variant="success" style={{ height: '0.5rem', backgroundColor: '#eeeeee69' }} />
                    </div>
                </div>
                {/* flex container */}
            </div>
            <div className="col-lg-4 col-md-12">
                <div style={{borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.2)',border:'none'}} className="card card-body bg-white text-black has-bg-image">
                    <div className='d-flex justify-content-between'>
                        <div className='media mb-3'>
                            <div className="media-body">
                                <h6 className="font-weight-semibold mb-0 fs-22">
                                CPS:
                                <span style={{fontSize:'20px',fontWeight:'bold',color:'#413839'}}> {cps} / </span> <span style={{fontSize:'20px',fontWeight:'bold',color:'#413839'}}>1000</span>
                                </h6>
                            </div>
                        </div>
                        <div className='d-flex flex-column'>
                            <div className="ml-2 align-self-center">
                                <i style={{color:'#03a9f3'}} class="icon-phone-wave fs-40x " />
                            </div>
                        </div>
                    </div>
                    {/* felx box container */}
                    <div className="mb-2">
                        <ProgressBar animated now={cps} max={1000} variant="info" style={{ height: '0.5rem', backgroundColor: '#eeeeee69' }} />
                    </div>
                </div>
            </div>
            <div className="col-lg-4 col-md-12">
                <div style={{borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.2)',border:'none'}} className="card card-body bg-white text-black has-bg-image">
                    <div className='d-flex justify-content-between'>
                        <div className='media mb-3'>
                            <div className="media-body">
                                <h6 className="font-weight-semibold mb-0 fs-22">
                                Accounts: 
                                <span style={{fontSize:'20px',fontWeight:'bold',color:'#413839'}}> {total}</span>
                                </h6>
                                {/* <span style={{fontSize:'14px',color:'#99abb4',textAlign:'end'}} className="opacity-75 fs-18">Total: <span style={{fontSize:'20px',color:'#455a64'}}>{total}</span></span> */}
                            </div>
                        </div>
                        {/* flex item 1 */}
                        <div className='d-flex flex-column'>
                            <div className="ml-2 align-self-center">
                                <i style={{color:'#fb9678'}} class="icon-users4 fs-40x " />
                            </div>
                        </div>
                        {/* flex item 2 */}
                    </div>
                    {/* flex container */}
                    <div className="mb-2">
                        <ProgressBar animated now={postpay} max={500} variant="danger" style={{ height: '0.5rem', backgroundColor: '#eeeeee69' }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MixState